export const OrderStatusEnum = {
    NEW: 'NEW',
    ACKNOWLEDGED: 'ACKNOWLEDGED',
    PREPARING: 'PREPARING',
    READY: 'READY',
    ON_DELIVERY: 'ON_DELIVERY',
    DELIVERED: 'DELIVERED',
    CANCELLED: 'CANCELLED',
} as const;

export type OrderStatus = (typeof OrderStatusEnum)[keyof typeof OrderStatusEnum];

export const PaymentStatusEnum = {
    UNPAID: 'UNPAID',
    PAID: 'PAID',
    REFUNDED: 'REFUNDED',
} as const;

export type PaymentStatus = (typeof PaymentStatusEnum)[keyof typeof PaymentStatusEnum];

export const OrderChannelEnum = {
    DELIVERY: 'DELIVERY',
    TAKEAWAY: 'TAKEAWAY',
    DINE_IN: 'DINE_IN',
} as const;

export type OrderChannel = (typeof OrderChannelEnum)[keyof typeof OrderChannelEnum];

export type DineInContext = {
    table?: string | null;
    covers?: number | null;
    area?: string | null;
    waiter?: string | null;
    seatings?: string | null;
    note?: string | null;
    checkInAt?: string | null;
};

export type TakeawayContext = {
    pickupAt?: string | null;
    pickupName?: string | null;
    contactless?: boolean | null;
    packagingNotes?: string | null;
};

export type OrderTimelineEntry = {
    at: string;
    label: string;
    status: OrderStatus;
    note?: string;
};

export type OrderItem = {
    id: string;
    name: string;
    quantity: number;
    price: number;
    total: number;
    modifiers?: string[];
    category?: string;
    station?: string;
    note?: string;
};

export type OrderAddress = {
    line1: string;
    line2?: string;
    city: string;
    postalCode: string;
    notes?: string;
};

export type OrderCustomer = {
    name: string;
    phone?: string;
    email?: string;
    taxId?: string;
    companyName?: string;
    address?: OrderAddress;
};

export type OrderNotes = {
    customer?: string;
    kitchen?: string;
    delivery?: string;
    billing?: string;
};

export type OrderCourier = {
    name: string;
    phone?: string;
    etaMinutes?: number;
    vehicle?: string;
};

export type DeliveryOrder = {
    id: string;
    backendId: string;
    code: string;
    createdAt: string;
    scheduledAt?: string;
    status: OrderStatus;
    channel: OrderChannel;
    paymentMethod: string;
    paymentStatus: PaymentStatus;
    total: number;
    serviceFee?: number;
    items: OrderItem[];
    customer: OrderCustomer;
    notes?: OrderNotes;
    timeline: OrderTimelineEntry[];
    tags?: string[];
    courier?: OrderCourier;
    dineIn?: DineInContext | null;
    takeaway?: TakeawayContext | null;
};
